<template>
  <div class="home-footer">
    <div class="home-footer-content">
      <div>
        <p>具身认知</p>
        <ul>
          <li>EEG-fNIRS双模态生理监测系统</li>
          <li>磁兼容心电门控</li>
          <li>肌电EMG无线采集单元</li>
          <li>多通道磁兼容神经电生理采集设备</li>
        </ul>
      </div>
      <div>
        <p>神经调控</p>
        <ul>
          <li>远端神经调控设备-电刺激手环</li>
          <li>经颅电刺激仪</li>
          <li>神经反馈训练平台</li>
        </ul>
      </div>
      <div>
        <p>交互平台</p>
        <ul>
          <li>LoongX 多模态数据采集平台</li>
          <li>LoongX 多模态数据分析平台</li>
          <li>LoongX 多模态开发者平台</li>
        </ul>
      </div>
      <div>
        <p>联系我们</p>
        <ul>
          <li >杭州荣脑科技有限公司</li>
          <li>qiancheng@loongbrain.net</li>
          <li>15957892799</li>
          <li style="width: 200px;">浙江省杭州市富阳区春江街道江南路68号第23幢506室</li>
        </ul>
      </div>
    </div>
    <div style="font-size: 14px;">
       <div class="copyright">
        @杭州荣脑科技有限公司 2025  <a target="_Blank" href="https://beian.miit.gov.cn/?spm=a2cmq.17630000.J_9220772140.106.73e079fe9GjOjO">浙ICP备2021006776号-1</a> 
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/layout/footer.vue